import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Captcha from 'react-google-recaptcha';
import { withStyles } from '@material-ui/core/styles';
import { NavigationLink, AppBar, TextField, Checkbox, Button } from '../components';
import { ThemeColors } from '../theme';
import Config from '../../run-config';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  federalState: '',
  businessPremises: '',
  modulesSelected: {},
  allowedToSave: false,
};

const steps = [
    { label: 'Unternehmensdaten', key: 0 },
    { label: 'Benutzer anlegen', key: 1 },
    { label: 'Bestätigen und Senden', key: 2 },
];


class CollectiveApplication extends Component {


  constructor(props) {
    super(props);

    this.state = {
      users: [],
      activeStep: 0,
            // activeStep: 'add_users',
      ...initialState,
    };

    this.modules = [
            { name: 'ironSTAR', key: 'ironstarChecked' },
            { name: 'buildingSTAR', key: 'buildingstarChecked' },
            { name: 'homeSTAR', key: 'homestarChecked' },
            { name: 'woodSTAR', key: 'woodstarChecked' },
    ];
  }

  onChangeTextField = (key, e) => {
    this.setState({
      [key]: e.target.value,
    });
  }

  onChangeCheckbox = (key, value) => {
    this.setState({ [key]: value });
  }


  onAddUser = () => {
    const user = {
      ...this.state,
    };
    const users = this.state.users;
    users.push(user);

    this.setState({
      ...initialState,
      users,
    });
  }

  onSend = () => {
        // var userList = [];

    const userList = this.state.users.map((user) => {
      const modules = this.modules.filter(f => user[f.key]).map(f => f.name);

      return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        federalState: user.federalState,
        businessPremises: user.businessPremises,
        additionalInfo: JSON.stringify(modules),
      };
    });

    const dto = {
      company: this.state.company,
      address: this.state.address,
      city: this.state.city,
      zip: this.state.zip,
      email: this.state.emailCompany,
      phone: this.state.phone,
      gisa: this.state.gisa,
      contactPerson: this.state.contactPerson,
      users: userList,
    };

    this.props.signup(dto);
  }

  onChangeCaptcha = (token) => {
    this.setState({ allowedToSave: true });
  }

  onCaptchaError = () => {
    this.setState({ allowedToSave: false });
  }

  isAllowedToContinue = () => {
    switch (this.state.activeStep) {
      case 0:
        return this.state.company && this.state.address && this.state.city &&
        this.state.zip && this.state.emailCompany && this.state.phone;
      case 1:
        return this.state.users && this.state.users.length > 0;
      default: return false;
    }
  }

  handleNext = () => {
    this.setState({ activeStep: this.state.activeStep + 1 });
  }

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  }

  canAddUser() {
    return this.state.firstName && this.state.lastName && this.state.email &&
    this.modules.find(m => this.state[m.key]);
  }

  canContinueFromCompanyForm() {
    return this.state.company && this.state.zip && this.state.address && this.state.city &&
            this.state.emailCompany && this.state.phone;
  }

  removeUser = (email) => {
    const users = this.state.users.filter(u => u.email !== email);
    this.setState({
      users,
    });
  }

  renderConfirmation() {
    if (!Config.useCaptcha) return null;

    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Captcha
          sitekey={Config.captchaClientKey}
          theme=""
          onChange={this.onChangeCaptcha}
          onErrored={this.onCaptchaError}
          onExpired={this.onCaptchaError}
        />
      </div>

    );
  }

  renderSelectedUsers = () => {
    if (!this.state.users || this.state.users.length < 1) return null;

    const users = this.state.users.map(u => (
      <TableRow key={u.email}>
        <TableCell>{u.firstName}</TableCell>
        <TableCell>{u.lastName}</TableCell>
        <TableCell>{u.email}</TableCell>
        <TableCell>
          {this.modules.filter(m => u[m.key]).map(a => <Typography>{a.name}</Typography>)}
        </TableCell>
        <TableCell align="center">
          <IconButton
            edge="start"
            onClick={() => this.removeUser(u.email)}
            color="inherit"
            aria-label="open remove user"
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
            ));

    return (
      <Paper elevation={2} style={{ marginTop: 20 }}>
        <Table aria-label="users-table">
          <TableHead>
            <TableRow>
              <TableCell>Vorname</TableCell>
              <TableCell>Nachname</TableCell>
              <TableCell>E-Mail</TableCell>
              <TableCell>Module</TableCell>
              <TableCell style={{ maxWidth: 20 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {users}
          </TableBody>
        </Table>
      </Paper>
    );
  }

  renderCheckbox = (text, key) => (
    <Checkbox
      checked={this.state[key]}
      onCheck={(e, value) => this.onChangeCheckbox(key, value)}
      style={{ display: 'block' }}
      label={text}
    />
        )

  renderBackButton() {
    if (this.state.activeStep < 1) return null;

    return (
      <Button
        label="Zurück"
        onClick={this.handleBack}
                // icon={<img src={restart} style={{ width: 45, height: 45 }} />}
        secondary
        labelStyle={{ textAlign: 'left', color: '#222', float: 'right' }}
      />
    );
  }

  renderNextButton() {
    if (this.state.activeStep >= steps.length - 1) {
      return (<Button
        label="Jetzt kostenpflichtig anmelden"
        onClick={this.onSend}
        disabled={!this.state.allowedToSave && Config.useCaptcha}
                // icon={<img src={restart} style={{ width: 45, height: 45 }} />}
        variant="contained"
        color="primary"
        labelStyle={{ textAlign: 'left', color: 'white', float: 'right' }}
      />);
    }
    return (<Button
      label="Weiter"
      variant="contained"
      color="primary"
      disabled={!this.isAllowedToContinue()}
      onClick={this.handleNext}
                // disabled={!this.canContinueFromCompanyForm()}
                // icon={<img src={restart} style={{ width: 45, height: 45 }} />}
      labelStyle={{ textAlign: 'left', color: 'white', float: 'right' }}
    />);
  }

  renderUserForm = () => (
    <Paper style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column' }} elevation={2}>
      <div style={{ display: 'flex', padding: 5, justifyContent: 'space-evenly' }}>
        <div
          className={'col-xs-8 col-sm-8 col-lg-8 col-md8'}
          style={{
            display: 'flex',
                            // justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <TextField
            autoFocus
            required
            style={{ marginRight: 10, width: '100%' }}
            placeholder="Vorname"
            value={this.state.firstName}
            onChange={e => this.onChangeTextField('firstName', e)}
          />
          <TextField
            autoFocus
            required
            style={{ marginRight: 10, width: '100%' }}
            placeholder="Nachname"
            value={this.state.lastName}
            onChange={e => this.onChangeTextField('lastName', e)}
          />
          <TextField
            autoFocus
            required
            style={{ marginRight: 10, width: '100%' }}
            placeholder="Bundesland"
            value={this.state.federalState}
            onChange={e => this.onChangeTextField('federalState', e)}
          />
          <TextField
            autoFocus
            required
            style={{ marginRight: 10, width: '100%' }}
            placeholder="Betriebsstätte des Teilnehmers"
            value={this.state.businessPremises}
            onChange={e => this.onChangeTextField('businessPremises', e)}
          />
          <TextField
            autoFocus
            required
            placeholder="E-Mail"
            style={{ width: '100%' }}
            value={this.state.email}
            onChange={e => this.onChangeTextField('email', e)}
          />
        </div>

        <div className={'col-xs-2 col-sm-2 col-lg-2 col-md2'} style={{ alignItems: 'left' }}>
          {this.modules.map(m => this.renderCheckbox(m.name, m.key))}

        </div>
      </div>
      <Button
        label="Benutzer bestätigen"
        onClick={this.onAddUser}
        disabled={!this.canAddUser()}
                    // icon={<img src={restart} style={{ width: 45, height: 45 }} />}
        secondary
        labelStyle={{ textAlign: 'left', color: '#222', float: 'right' }}
      />
    </Paper>

        )

  renderCompanyInformationForm() {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <TextField
          autoFocus
          required
          style={{ marginRight: 10, width: '100%' }}
          placeholder="Unternehmensname"
          value={this.state.company}
          onChange={e => this.onChangeTextField('company', e)}
        />
        <TextField
          autoFocus
          required
          style={{ marginRight: 10, width: '100%' }}
          placeholder="GISA Zahl"
          value={this.state.gisa}
          onChange={e => this.onChangeTextField('gisa', e)}
        />

        <TextField
          autoFocus
          required
          style={{ marginRight: 10, width: '100%' }}
          placeholder="Ansprechpartner Betrieb"
          value={this.state.contactPerson}
          onChange={e => this.onChangeTextField('contactPerson', e)}
        />
        <TextField
          autoFocus
          required
          style={{ marginRight: 10, width: '100%' }}
          placeholder="Adresse"
          value={this.state.address}
          onChange={e => this.onChangeTextField('address', e)}
        />
        <TextField
          autoFocus
          required
          placeholder="PLZ"
          style={{ width: '100%' }}
          value={this.state.zip}
          onChange={e => this.onChangeTextField('zip', e)}
        />
        <TextField
          autoFocus
          required
          placeholder="Stadt/Ort"
          style={{ width: '100%' }}
          value={this.state.city}
          onChange={e => this.onChangeTextField('city', e)}
        />
        <TextField
          autoFocus
          required
          placeholder="E-Mail"
          style={{ width: '100%' }}
          value={this.state.emailCompany}
          onChange={e => this.onChangeTextField('emailCompany', e)}
        />
        <TextField
          autoFocus
          required
          placeholder="Telefon"
          style={{ width: '100%' }}
          value={this.state.phone}
          onChange={e => this.onChangeTextField('phone', e)}
        />
      </div>
    );
  }

  renderUserSelection() {
    return (
      <div>
        {this.renderUserForm()}
        {this.renderSelectedUsers()}
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (

      <div className={classes.containerStyle}>
        <AppBar
          title="Benutzer registrieren"
          typography={{
            textAlign: 'center',
            textTransform: 'uppercase',
            fontSize: 16,
            color: 'white',
          }}
          showMenuIconButton={false}
          styles={{
            textAlign: 'center',
          }}
          className={classes.appBarStyle}
        />

        <div
          className={classes.formGroupStyle}
          style={{
            padding: 10,
          }}
        >

          <Stepper activeStep={this.state.activeStep} >
            {steps.map(s => (
              <Step
                key={s.key}
                active={this.state.activeStep === s.key}
              >
                <StepLabel
                  StepIconProps={{
                    classes: {
                      text: classes.iconStyle,
                    },
                  }}
                >
                  {s.label}</StepLabel>
              </Step>
                            ))}
          </Stepper>

          {this.state.activeStep === 0 ? this.renderCompanyInformationForm() : null}
          {this.state.activeStep === 1 ? this.renderUserSelection() : null}
          {this.state.activeStep === 2 ? this.renderConfirmation() : null}
          <br />
          <div
            style={{
              display: 'flex',
              justifyContent: this.renderBackButton() ? 'space-between' : 'flex-end',
            }}
          >
            {this.renderBackButton()}
            {this.renderNextButton()}
          </div>
          <br />
          <NavigationLink to="/">zur Startseite</NavigationLink>

        </div>
      </div>
    );
  }
}

const styles = () => ({
  iconStyle: {
    fill: 'white',
  },
  formGroupStyle: {
    width: '100%',
    textAlign: 'center',
  },
  containerStyle: {
    maxWidth: 750,
    margin: '0 auto',
    marginTop: 20,
        // marginTop: 'calc(50vh - 215px)',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
  },
  appBarStyle: {
    height: '80px',
    backgroundColor: ThemeColors.primary1Color,
    boxShadow: '',
    flexDirection: 'row',
    justifyContent: 'center',
    disabled: 'flex',
    alignItems: 'center',
    textAlign: 'center',
  },
});

CollectiveApplication.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(CollectiveApplication);



// WEBPACK FOOTER //
// ./src/app/collective-application/collective-application.js